const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      title: "Quick Sign-up",
      description: "Enter your mobile number and PAN to start the journey."
    },
    {
      number: "02",
      title: "Video KYC",
      description: "A 30-second secure selfie-check for instant verification."
    },
    {
      number: "03",
      title: "Select Limit",
      description: "Choose the amount you need from your approved limit."
    },
    {
      number: "04",
      title: "Direct Transfer",
      description: "Funds hitting your bank account in real-time. Instantly."
    }
  ];

  return (
    <section className="w-full pt-28 pb-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 md:mb-16 gap-6 md:gap-8">
          <div className="max-w-2xl w-full">
            <p className="text-[var(--primary)] text-[11px] md:text-[13px] font-bold tracking-[0.2em] uppercase mb-2 md:mb-3 font-sans">
              THE PROTOCOL
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-5xl font-serif text-black leading-[1.1] font-bold">
              How it works
            </h2>
          </div>

          <div className="flex flex-col items-start md:items-end min-w-fit w-full sm:w-auto">
            <p className="text-[var(--text-gray)] text-xs sm:text-sm md:text-base lg:text-lg mb-1 md:mb-2 font-sans opacity-70 whitespace-normal md:whitespace-nowrap">
              Streamlined for velocity.
            </p>
            <div className="w-32 md:w-full h-[1.5px] md:h-[2px] bg-[var(--primary)]/80" />
          </div>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 md:gap-x-12 gap-y-10 md:gap-y-16">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-start group">
              {/* Large light number - more compact for mobile */}
              <div className="text-4xl md:text-7xl font-serif text-[var(--text-gray-light)] leading-none mb-2 md:mb-6 opacity-20 select-none font-medium tracking-tighter">
                {step.number}
              </div>
              
              {/* Step Title */}
              <h3 className="text-lg md:text-2xl lg:text-xl font-serif font-bold text-black mb-1 md:mb-4 leading-tight">
                {step.title}
              </h3>
              
              {/* Step Description */}
              <p className="text-[var(--text-gray)] text-[13px] md:text-base lg:text-sm leading-relaxed opacity-80 font-sans max-w-[280px]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
